// extracted by mini-css-extract-plugin
export default {"placeholderHeading":"Placeholder_placeholderHeading__5jY1k"};